/* tslint:disable max-line-length*/
import { Injectable,  ComponentFactoryResolver, ApplicationRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { FakeUserInfo } from './fake-user-info';
import { NotifyMessageCount, User } from '../../_model/user/user.model';
import { ApiUrlHelper } from '../api-url-helper';
import { UserTransFormer } from '../../_transformers/user.transformer';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { HttpClientHelper } from '../http-helper';
import { environment } from '../../../environments/environment';
import { Utility } from '../utility';
import { StorageService } from '../../storageprovider';
import { delay, map,shareReplay} from 'rxjs/operators';
import { SocketFacade } from 'app/_modules/socket/socket.facade';
import { DynamicComponentLoader } from '../dynamicComponentLoader.service';

@Injectable({
    providedIn: "root"
})
export class UserService {

    user: User = new User(true);
    notifications:NotifyMessageCount=new NotifyMessageCount();
    //allVip = false;
    private _loginBoxService = new Subject<any>();
    loginBoxSource$ = this._loginBoxService.asObservable();

    ///用户信息的修改
    private userState = new BehaviorSubject<User>(this.user);
    userState$ = this.userState.asObservable();

    private notificationState = new BehaviorSubject<NotifyMessageCount>(this.notifications); 
    notificationState$ = this.notificationState.asObservable();

    constructor(
    
        private _httpClientHelper: HttpClientHelper,
        private _apiUrlHelper: ApiUrlHelper,
        private _userTransFormer: UserTransFormer,
        private _cookieService: CookieService,
        private _router: Router,
        private _storage: StorageService,
        private socketFacade: SocketFacade,
        private _utility:Utility,
        private _dcl:DynamicComponentLoader
    ) {
        // store.subscribe(() => this.readState());
        // this.readState();
        this.userState$.subscribe(p => {
            this.user = p;
        })
    }

    ///更新数据
    updateNotify(obj:any)
    {
        var needUpdate = false;
        Object.keys(this.notifications).forEach(p=>{
            if(obj[p] != undefined && obj[p] != this.notifications[p])
            {
                needUpdate = true;
            }
        })
        if(needUpdate)
        this.notificationState.next(Object.assign(this.notifications, obj));
    }

    ///更新用户数据
    updateUserData(data) {
        
        this.user = Object.assign(this.user, data,{
            token:this._httpClientHelper.token
        });
        this.userState.next(this.user);

    }

    ///更新用户token
    updateUserToken(token) {
       // console.log("update token",token)
        //this.user.token = token;
        this._httpClientHelper.token = token;
        this._storage.SetSessionData({ "__t": JSON.stringify(token) });
        this._storage.SetSessionData({ "token": token.token })
    }

    getCurrentUser(): Observable<any> {
        return of(FakeUserInfo).pipe(delay(200));
    }

    shortCut(pconfig) {
        this._httpClientHelper.invokeCert(pconfig);
    }
    bindUserAccount(user): Observable<any> {

        const apiURL = 'https://api.anygate.vip/api/ThirdPartyLogin/GetBindUrl';// + ApiUrlHelper.toQueryString(token));

        return this._httpClientHelper.get(apiURL, true)
            .pipe(map(res => {
                return res;
            }));
    }

    /*
    ** 收藏一个视频
    */
    favorite(id: string, onUserNotLogin) {
        var result: Observable<any>;
        if (this.user.id > 0) {
            const apiURL = this._apiUrlHelper.urlBuilder('video-teaser-favorite', {
                videoID: id,
            });
            result = this._httpClientHelper.get(apiURL)
                .pipe(map((res) => {
                    return res;
                })).pipe(delay(300));
        }
        else {
            onUserNotLogin();
            result = of({
                code: 401
            });
        }
        return result;

    }

    removeFavorite(id: string, onUserNotLogin) {
        var result: Observable<any>;
        if (this.user.id > 0) {

            const apiURL = this._apiUrlHelper.urlBuilder('video-remove-favorite', {
                videoID: id,
            });
            result = this._httpClientHelper.get(apiURL)
                .pipe(map((res) => {
                    return res;
                })).pipe(delay(300));
        }
        else {
            onUserNotLogin();
            result = of({
                code: 401
            });

        }
        return result;

    }
    /*
    ** 已由系统转发
    */
    transformData(user: User) {

        //console.log(user)
        this.user = user;
        var token = Object.assign({
            uid: user.id,
        }, user.token);
        var jsonString = JSON.stringify(token)
        this._httpClientHelper.token = token;
        this._storage.SetSessionData({ "__t": jsonString });
        this._cookieService.set(
            'autologin',
            user.autoKey,
            10000,
            '/',
            this._utility.GetHost("", true),
            true,
            "Lax"
        );

        this.getAuthorizedUserInfo(user).subscribe();

    }

    /*
    ** login with current save data;
    */
    login(): Observable<any> {
        // 用 token
        let newUser = new User(false);
        const token = this._storage.GetSessionData("token");// this._cookieService.get('dn_token');
        if (token) {
            this.validateToken(token).subscribe(res => {
                if (res) {
                    newUser = res;
                    this.getAuthorizedUserInfo(newUser).subscribe();
                    return res;
                } else {
                    // console.log('isme 11');
                    this.logout();
                    return res;
                }
            });
        }
        return of([]);
    }

    private lastValidate;
    private last;
    //count = 0;
    validateToken(token, remeberMe = false): Observable<any> {

        var apiURL = this._apiUrlHelper.API_ENDPOINT() + "/user/validate?token=" + token;
        if (environment.app || remeberMe) {
            apiURL += "&autologin=1"
        }
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                if (res[0]) {
                    const user = this._userTransFormer.fromValidateToken(res[0]);
                    //this.userState.next(user);
                    //this.store.dispatch({ type: userActions.LOGIN, user: user });
                    return user;
                } else {
                    return undefined;
                }
            }));
    }

    logout() {
        var token = this._storage.GetSessionData("token");
        this._httpClientHelper.token = {};
        this._storage.RemoveSessionData("token");
        this._storage.RemoveSessionData("__t");
        this._cookieService.delete('autologin', '/',  this._utility.GetHost("", true));

        if (!!window['DN_Logout']) {
            window['DN_Logout'](token);
        }
        localStorage.removeItem('showWY'); // 退出登录清除午夜设置
        this.userState.next(new User(true));
        this._router.navigate(['/']);
        if (environment.app) {
            window["UserLogout"]();
        }
        this.socketFacade.clearAll();

    }


    loginUserWithKey(key) {
        const apiURL = this._apiUrlHelper.urlBuilder('user-auto', { autologin: key });
        console.log("auto login")
        return this._httpClientHelper.get(apiURL).subscribe(res => {
            if (res && res.length && res[0] != null) {
                this.validateToken(res[0]).subscribe((data) => {
                    if (data) {
                        //console.log(data)
                        this.user = data;
                        this.updateUserToken(Object.assign({
                        },data["token"],{uid:this.user.id}));
                        this.getAuthorizedUserInfo(data).subscribe();
                        
                    }
                });
            }
            else {
                this._cookieService.delete("autologin", "/",  this._utility.defaultHost)
            }
        });
    }

    getUserInfo(uid): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('user-info', { touid: uid });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return this._userTransFormer.fromGetUserInfo(res[0]);
            }));//.pipe(delay(200));
    }

    cachedUsers$ = null;
    getAuthorizedUserInfo(user): Observable<any> {
        if (!this.cachedUsers$) {
            const apiURL = this._apiUrlHelper.urlBuilder('authorized-user-info', {
            });
            this.cachedUsers$ = this._httpClientHelper.get(apiURL)
                .pipe(map(res => {
                    const u = this._userTransFormer.fromGetAuthorizedUserInfo(res[0]);
                    this.updateUserData(u);
                    setTimeout(()=>this.cachedUsers$ = null,1000);
                    return u;
                }),
                shareReplay(1,1000)
                );

        
          }
          return this.cachedUsers$;

 
    }

    getUserPermissions(user): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('user-permissions', {

        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {

                const items = res.map((item, index) => {
                    if (environment.cinema === 1) {
                        if (index === 0) {
                            item.Title = '观看标清视频';
                            item.icon = 'view-std-video';
                        }
                        if (index === 1) {
                            item.icon = 'publish-comment';
                        }
                        if (index === 2) {
                            item.icon = 'favorite';
                        }
                        if (index === 3) {
                            item.icon = 'autoplay-next-episode';
                        }
                        if (index === 4) {
                            item.icon = 'record-last-position';
                        }
                        if (index === 5) {
                            item.icon = 'create-poll';
                        }
                        if (index === 6) {
                            item.icon = 'define-danmu-color';
                        }
                        if (index === 7) {
                            item.icon = 'vip-emotions';
                        }
                        if (index === 8) {
                            item.icon = 'speed';
                        }
                        if (index === 9) {
                            item.icon = 'identification';
                        }
                        if (index === 10) {
                            item.icon = 'ad-pause';
                        }
                        if (index === 11) {
                            item.icon = 'advertisement-filter';
                        }
                        if (index === 12) {
                            item.Title = '观看超清视频';
                            item.icon = 'view-hd-video';
                        }
                        if (index === 13) {
                            item.icon = 'download';
                        }
                        if (index === 14) {
                            item.icon = 'request';
                        }
                        if (index === 15) {
                            item.icon = 'view-adult-video';
                        }
                        if (index === 16) {
                            item.icon = 'private-collection';
                        }
                        if (index === 17) {
                            item.icon = 'no-mosaic';
                        }
                        return item;
                    } else {
                        if (index === 0) {
                            item.Title = '观看骑兵片';
                            item.icon = 'view-adult-video';
                        }
                        if (index === 1) {
                            item.icon = 'publish-comment';
                        }
                        if (index === 2) {
                            item.icon = 'favorite';
                        }
                        if (index === 3) {
                            item.Title = '超大收藏夹';
                            item.icon = 'private-collection';
                        }
                        // if (index === 4) {
                        //     item.icon = 'autoplay-next-episode';
                        // }
                        if (index === 4) {
                            item.icon = 'record-last-position';
                        }
                        if (index === 5) {
                            item.icon = 'create-poll';
                        }
                        if (index === 6) {
                            item.icon = 'define-danmu-color';
                        }
                        if (index === 7) {
                            item.icon = 'vip-emotions';
                        }
                        if (index === 8) {
                            item.icon = 'speed';
                        }
                        if (index === 9) {
                            item.icon = 'identification';
                        }
                        if (index === 10) {
                            item.icon = 'ad-pause';
                        }
                        if (index === 11) {
                            item.icon = 'advertisement-filter';
                        }
                        if (index === 12) {
                            item.icon = 'no-mosaic';
                        }
                        if (index === 13) {
                            item.icon = 'download';
                        }


                        return item;
                    }
                });

                return items;
            }));
    }

    getUserNotifications(user: undefined) {
        if (user) {
            const r = {
                favorites: Math.floor((Math.random() * 1000) + 1),
                messages: Math.floor((Math.random() * 100) + 1)
            };
            //this.store.dispatch({ type: userActions.UPDATENOTIFICATIONS, notifications: r });
        }
    }

    isLoginBoxLoaded = false;
    async showLoginDialog(value) {
        if (value && !this.isLoginBoxLoaded) {
            this.isLoginBoxLoaded = true;
            const { LoginBoxComponent } = await import("../../login-box/login-box.component");
            let ref = this._dcl.createComponent(LoginBoxComponent);
            ref.instance.showBox = value;
            ref.instance.loading = true;
            ref.instance.DN_Init();
        }
        this._loginBoxService.next(value);
    }
  



    shouldrenewUser = false;

    /**
    * 更新用户状态,如果返回false，请持续获取，否则取消获取
    */
    renewCurrentUser() {
        this.shouldrenewUser = true;

    }


    cancelRenew() {
        this.shouldrenewUser = false;

    }

    public liveTimer = null;
    getuserLiveTest(user, callback): void {
        // this.clearResult();
        // this.timerResult(user, callback);
    }
    checkTime = environment.production ? 60000 : 6 * 1000;

    clearResult() {
        this._utility.clearTimeout(this.liveTimer);
    }
    /* */
    public extendSign(data) {
        return this._httpClientHelper.post(this._apiUrlHelper.API_ENDPOINT() + '/user/ExtendSign?', data, null);
    }

    public clearOverWatch(data) {
        return this._httpClientHelper.post(this._apiUrlHelper.APIV3_ENDPOINT("api") + '/home/ClearWatch?', data, null);
    }
    isTest = true;






}
